<template>
    <div class="form-group">
        <label v-if="label" class="label" :for="id">{{ label }}:</label>
        <input
            :id="id"
            ref="input"
            v-bind="$attrs"
            :class="{'form-control':true,'is-invalid form-control-danger':errors.length}"
            :type="type"
            :value="value"
            :placeholder="placeholder"
            :disabled="disabled"
            @focus="$emit('focus', $event)"
            @blur="$emit('blur', $event)"
            @input="$emit('input', $event.target.value)"
            @keyup.enter="$emit('onEnter')"
        />
        <small v-if="errors.length === 0 && description !== null" class="form-text text-muted" v-html="description"></small>
        <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
    </div>
</template>

<script>

export default {
    inheritAttrs:false,

    methods:{
        focusField(){
            this.$refs.input.focus()
        },
    },

    mounted() {
        if (this.focus === true) {
            setTimeout(() => this.focusField(), 200);
        }
    },

    props:{
        description:{
            type:String,
            default:null,
        },
        disabled: {
            type:Boolean,
            default:false,
        },
        errors:{
            type:Array,
            default:() => [],
        },
        focus:{
            type:Boolean,
            default:false,
        },
        id:{
            type:String,
            default(){
                return `text-input-${this._uid}`
            },
        },
        label:String,
        placeholder:{
            type:String,
            default:"",
        },
        type:{
            type:String,
            default:'text',
        },
        value:{
            required:true,
        },
    },
}

</script>
